import { giphyBlack } from '@giphy/js-brand'
import React, { FunctionComponent, ReactNode, useContext } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_LARGE } from '../../constants'
import CreationToolError from '../../types/error'
import CreationToolSourceEditor from '../../types/source-editor'
import UploadButton from '../upload-button'
import CaptionPanel from './caption'
import CropPanel from './crop'
import EditPanel from './edit'
import FiltersPanel from './filters'
import { CreationSourceEditorContext } from './manager'
import StickersPanel from './stickers'
import { SourceEditorEdits } from './types'
import WatermarkPanel from './watermark'

const Container = styled.div`
    background: ${giphyBlack};
    border-radius: ${BORDER_RADIUS_LARGE}px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin: 0 15px;
    width: 750px;
`

const Panel = styled.div`
    display: grid;
    gap: 30px;
    grid-template-columns: repeat(8, 1fr);
    padding: 30px;
`

const DoneButtonWrapper = styled.div`
    background: linear-gradient(0deg, rgba(18, 18, 18, 1) 0%, rgba(18, 18, 18, 1) 50%, rgba(18, 18, 18, 0) 100%);
    bottom: 0;
    margin-top: 50px;
    padding-bottom: 30px;
    position: sticky;
`

const DoneButton = styled(UploadButton)`
    margin: 0 auto;
    width: 500px;
`

const getEditorComponent = (editor: CreationToolSourceEditor): FunctionComponent => {
    switch (editor) {
        case CreationToolSourceEditor.Edit:
            return EditPanel
        case CreationToolSourceEditor.Crop:
            return CropPanel
        case CreationToolSourceEditor.Caption:
            return CaptionPanel
        case CreationToolSourceEditor.Filters:
            return FiltersPanel
        case CreationToolSourceEditor.Stickers:
            return StickersPanel
        case CreationToolSourceEditor.Watermark:
            return WatermarkPanel
    }
}

type Props = {
    children?: ReactNode
    onDone: (edits?: SourceEditorEdits) => void
}

const CreationSourceEditorPanel = ({ children, onDone }: Props) => {
    const { currentEditor, edits, artboardRef, error } = useContext(CreationSourceEditorContext)
    const PanelComponent = getEditorComponent(currentEditor)

    const onDoneClick = () => {
        const frames = artboardRef.current?.getFrames()
        onDone({
            ...edits,
            frames: frames && frames.length ? frames : undefined,
        })
    }

    return (
        <Container>
            {children}
            <Panel>
                <PanelComponent />
            </Panel>
            <DoneButtonWrapper>
                <DoneButton disabled={!!error} onClick={onDoneClick}>
                    {error ? CreationToolError.description(error) : 'Done'}
                </DoneButton>
            </DoneButtonWrapper>
        </Container>
    )
}

export default CreationSourceEditorPanel
